import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';

import { Icon, IconBuses } from '@flixbus/honeycomb-icons-react';
import {
	LegacyAutocomplete as Autocomplete,
	LegacyAutocompleteInput as AutocompleteInput,
	LegacyAutocompleteOptions as AutocompleteOptions,
} from '@flixbus/honeycomb-react';

import { FILTER_TYPES } from 'pages/RideListPage/components/RideFilters/filterConstants';
import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';

import { buildTripNumberOptions } from './buildTripNumberOptions';
import { TRIP_NUMBERS_FILTER_TEXT } from './texts';

const TripNumbers = observer(() => {
	const [inputValue, setInputValue] = useState('');
	const [valueToShow, setValueToShow] = useState('');

	const onDebounce = (e) => {
		if (!e.target.value) return;
		setValueToShow(e.target.value);
	};

	const onSelect = (item) => {
		rideFilterStore.addFilter({
			value: item.title,
			type: FILTER_TYPES.trip,
		});
		setInputValue('');
		setValueToShow('');
	};

	const checkEmpty = (e) => {
		if (e.target.value === '') {
			setValueToShow('');
		}
		setInputValue(e.target.value);
	};

	return (
		<Autocomplete
			onDebounce={(e) => onDebounce(e)}
			onSelect={(item) => {
				onSelect(item);
			}}
			onChange={(e) => {
				checkEmpty(e);
			}}
			options={buildTripNumberOptions(valueToShow)}
			value={''}
			label={TRIP_NUMBERS_FILTER_TEXT.outerLabel}
			placeholder={TRIP_NUMBERS_FILTER_TEXT.placeholder}
		>
			<AutocompleteInput
				id="tripNumber"
				label={TRIP_NUMBERS_FILTER_TEXT.inputLabel}
				iconLeft={<Icon InlineIcon={IconBuses} />}
				placeholder={TRIP_NUMBERS_FILTER_TEXT.placeholder}
				infoError={TRIP_NUMBERS_FILTER_TEXT.infoError}
				type="search"
				value={inputValue}
			/>
			<AutocompleteOptions label={TRIP_NUMBERS_FILTER_TEXT.optionsLabel} optionsToDisplay={5} />
		</Autocomplete>
	);
});

export default TripNumbers;
